export default "__VITE_ASSET__DsX311vE__"